import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './select-report-parameters-dialog.controller';
import template from './select-report-parameters-dialog.html';

class dialogService {
  getOptions($event, { hasAdvisoryServices, reportPackageId, reportPackage, reportPackageConfiguration, editMode }) {
    return {
      controller,
      controllerAs: 'selectReportParametersDialogVM',
      locals: {
        hasAdvisoryServices,
        reportPackageId,
        reportPackage,
        reportPackageConfiguration,
        editMode
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular
  .module('app.components.reports.packageReports.selectReportParametersDialog', [
    alerts,
    amDataService,
    constants,
    docDataService,
    loaderService,
    orgDataService,
    ssDialogService,
    userService,
  ])
  .service('selectReportParametersDialog', dialogService).name;
